var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-cog",
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#000",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21v-2a4 4 0 0 1 4 -4h2.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 15.5v1.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 21v1.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.032 17.25l-1.299 .75"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.27 20l-1.3 .75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.97 17.25l1.3 .75"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.733 20l1.3 .75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.122be3828324bc6151a624f07bd8a7c5.svg";
export { ForwardRef as ReactComponent };